import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";
import * as rx from "rxjs";

import type {
  FssTeamInfo,
  Service,
} from "@mirage/service-fss-team-info/service";

export const service = services.get<Service>(ServiceId.FSS_TEAM_INFO);

export function getFssTeamInfo(): Promise<FssTeamInfo | undefined> {
  return rx.firstValueFrom(service.getFssTeamInfo());
}
